export default "__VITE_ASSET__DvScVA17__"